import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';

const FAQSection = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = [
    {
      question: 'What types of legal services do you offer?',
      answer: 'We provide comprehensive legal services including corporate law, business formation, intellectual property protection, compliance, immigration, and litigation. Our expertise covers trademark and copyright registration, mergers and acquisitions, government contracting, and anti-corruption compliance.',
    },
    {
      question: 'How do I schedule a consultation?',
      answer: 'You can schedule a consultation by filling out our contact form, calling our office directly, or clicking the "Get Legal Help" button on our website. We offer both in-person and virtual consultations to accommodate your schedule.',
    },
    {
      question: 'What are your fees?',
      answer: 'Our fee structure varies depending on the type of service and complexity of your case. We offer transparent pricing and will provide a detailed fee agreement during your initial consultation. Many services are available on both hourly and flat-fee basis.',
    },
    {
      question: 'How long does trademark registration take?',
      answer: 'Trademark registration typically takes 8-12 months from filing to approval, though timelines can vary. We handle the entire process including comprehensive trademark searches, application preparation, office action responses, and final registration.',
    },
    {
      question: 'Do you handle cases nationwide?',
      answer: 'Yes, we represent clients across the United States. Our attorneys are licensed in multiple jurisdictions and we have extensive experience handling federal matters, including USPTO proceedings and federal court litigation.',
    },
    {
      question: 'What should I bring to my first consultation?',
      answer: 'Please bring any relevant documents related to your legal matter, such as contracts, correspondence, corporate documents, or intellectual property materials. A list of questions and your business objectives will also help us provide more targeted advice.',
    },
  ];

  return (
    <section className="py-24 md:py-32 bg-white" data-testid="faq-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-start">
          <div>
            <div className="text-sm uppercase tracking-[0.2em] font-medium text-[#2C3E50] mb-4">
              FAQ
            </div>
            <h2 className="font-['Playfair_Display'] text-3xl lg:text-4xl tracking-tight text-[#2E2E2E] mb-8">
              Frequently Asked Questions
            </h2>

            <div className="space-y-4">
              {faqs.map((faq, index) => (
                <div
                  key={index}
                  className="border border-[#2C3E50]/10 bg-white"
                  data-testid={`faq-item-${index}`}
                >
                  <button
                    onClick={() => setOpenIndex(openIndex === index ? null : index)}
                    className="w-full flex items-center justify-between p-6 text-left hover:bg-[#F8F9FA] transition-colors"
                    data-testid={`faq-question-${index}`}
                  >
                    <span className="font-semibold text-[#2C3E50] pr-4">{faq.question}</span>
                    <ChevronDown
                      className={`w-5 h-5 text-[#CA9A67] flex-shrink-0 transition-transform ${
                        openIndex === index ? 'rotate-180' : ''
                      }`}
                    />
                  </button>
                  {openIndex === index && (
                    <div className="px-6 pb-6 text-[#2E2E2E]/80 leading-relaxed" data-testid={`faq-answer-${index}`}>
                      {faq.answer}
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>

          <div className="hidden lg:block sticky top-32">
            <img
              src="https://images.unsplash.com/photo-1589829545856-d10d557cf95f?w=800&q=80"
              alt="Legal consultation and guidance"
              className="w-full h-[540px] object-cover shadow-lg"
              data-testid="faq-image"
            />
            <div className="bg-[#CA9A67] p-6 mt-0">
              <h3 className="text-white font-semibold text-lg mb-2">Need Personalized Guidance?</h3>
              <p className="text-white/80 text-sm leading-relaxed">Our attorneys are ready to answer your specific legal questions and provide tailored solutions.</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
